export enum SortOptions {
  RECENTES = 'recentes',
  TIPO = 'tipo',
}
